<div class="card">
  <app-header
    [titulo]="isEditMode ? 'Editar Provedor' : 'Novo Provedor'"
    [descricao]="isEditMode ? 'Atualize o nome e a descrição da fonte de dados' : 'Cadastre uma fonte de dados e configure como o sistema vai acessá-la'">
  </app-header>

  <div class="info-message mb-4" *ngIf="!isEditMode" role="note">
    <i class="pi pi-info-circle"></i>
    <span>Preencha primeiro os dados do provedor e depois a conexão do ambiente que deseja usar. Campos com * são obrigatórios.</span>
  </div>

  <form [formGroup]="form" (ngSubmit)="salvar()">

    <!-- Seção: Informações do Provedor -->
    <section class="form-step">
    <div class="p-fluid grid">
      <div class="col-12">
        <h5 class="section-title">{{ isEditMode ? 'Informações do provedor' : '1. Identifique a fonte de dados' }}</h5>
      </div>

      <div class="field col-12 md:col-6">
        <p-floatLabel>
          <input
            pInputText
            id="nome"
            formControlName="nome"
            [class.ng-invalid]="campoInvalido('nome')"
            [class.ng-dirty]="campoInvalido('nome')"
          />
          <label for="nome">Nome do Provedor *</label>
        </p-floatLabel>
        <small class="p-error" *ngIf="campoInvalido('nome')">
          Nome é obrigatório (mínimo 3 caracteres)
        </small>
        <small class="p-text-secondary">Ex.: ERP de vendas ou API de pedidos.</small>
      </div>

      <div class="field col-12 md:col-6">
        <p-floatLabel>
          <p-dropdown
            id="tipo"
            formControlName="tipo"
            [options]="tiposProvedor"
            optionLabel="label"
            optionValue="value"
            [style]="{'width':'100%'}"
          ></p-dropdown>
          <label for="tipo">Tipo de Provedor *</label>
        </p-floatLabel>
        <small class="p-text-secondary" *ngIf="isEditMode">
          O tipo não pode ser alterado depois de criado.
        </small>
      </div>

      <div class="field col-12">
        <p-floatLabel>
          <textarea
            pInputTextarea
            id="descricao"
            formControlName="descricao"
            rows="3"
          ></textarea>
          <label for="descricao">Descrição</label>
        </p-floatLabel>
      </div>
    </div>
    </section>

    <!-- Edição: conexões e credenciais têm tela própria -->
    <ng-container *ngIf="isEditMode">
      <div class="info-message mt-4">
        <i class="pi pi-info-circle"></i>
        <span>
          As conexões (ambientes), credenciais e endpoints deste provedor são gerenciados na tela de conexões.
        </span>
        <p-button
          label="Gerenciar conexões"
          icon="pi pi-link"
          severity="info"
          [outlined]="true"
          (onClick)="gerenciarConexoes()"
          [disabled]="loading"
        ></p-button>
      </div>
    </ng-container>

    <!-- Criação: primeira conexão e credencial -->
    <ng-container *ngIf="!isEditMode">
      <section class="form-step mt-4">
      <div class="p-fluid grid">
        <div class="col-12">
          <h5 class="section-title">2. Configure a primeira conexão</h5>
          <p class="text-600 mt-0">A conexão guarda o endereço e a credencial de um ambiente, como produção ou homologação.</p>
        </div>
      </div>

      <app-conexao-campos [form]="form" [tipoProvedor]="tipoProvedor"></app-conexao-campos>
      </section>
    </ng-container>

    <!-- Botões de Ação -->
    <div class="flex justify-content-end gap-2">
      <p-button
        label="Voltar"
        icon="pi pi-arrow-left"
        severity="secondary"
        (onClick)="voltar()"
        [disabled]="loading"
      ></p-button>

      <p-button
        label="Recomeçar"
        icon="pi pi-times"
        severity="warning"
        (onClick)="limpar()"
        [disabled]="loading"
        *ngIf="!isEditMode"
      ></p-button>

      <p-button
        [label]="isEditMode ? 'Atualizar' : 'Salvar'"
        icon="pi pi-check"
        severity="success"
        type="submit"
        [loading]="loading"
      ></p-button>
    </div>
  </form>
</div>
